import { Component } from '@angular/core';
import {Store} from "@ngrx/store";
import {ActivatedRoute, Router} from "@angular/router";
import * as interfaceSelectors from "../../state/interface/interface.selector";
import * as UserSelectors from "../../state/users/users.selector";
import {User} from "../../auth/primitives/user";
import {FilesService} from "../../services/files/files.service";
import {Base64ImageComponent} from "../base64-image/base64-image.component";
import {NgIf} from "@angular/common";
import {ProfileImageComponent} from "../profile-image/profile-image.component";
import {interfaceActions} from "../../state/interface/interface.actions";
import {IconsService} from "../../services/icons.service";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {newChat} from "../../state/chats/chat.effects";
import {ChatsService} from "../../services/chats.service";

@Component({
  selector: 'context-profile',
  standalone: true,
  imports: [
    Base64ImageComponent,
    NgIf,
    ProfileImageComponent,
    FaIconComponent
  ],
  templateUrl: './context-profile.component.html',
  styleUrl: './context-profile.component.scss'
})
export class ContextProfileComponent {

  userId: string = null
  user: User = null
  profileImageB64: string = null
  constructor(
      private store: Store,
      private route: ActivatedRoute,
      private fileService: FilesService,
      protected iconsService: IconsService,
      private chatService: ChatsService,
      private router: Router
  ) {
    this.route.queryParams.subscribe(params => {
      this.userId = params["userId"];
      this.store.select(UserSelectors.selectUserById(this.userId)).subscribe(async (user) => {
        this.user = user
        const serverFile = await this.fileService.getFile(user.profile_image_file_id)
        this.profileImageB64 = serverFile.fileData
      })
    });
  }

  async closeContextMenu() {
    await this.router.navigate( [{outlets: {'context-menu': null}}], { queryParamsHandling: 'preserve' })
    this.store.dispatch(interfaceActions.closeContextMenu())
  }

  async openChat() {
    await this.chatService.openChatWith(this.userId)
    await this.closeContextMenu()
  }

  viewProfile() {

  }
}
